// @flow
import client from '../../client'

// Types
import type { TTravelAgent } from './register'

// API Endpoints
export const COMPANY_ENDPOINT = '/travel_agent/company/'

/**
 * Returns an update company
 * @param {Object} data Company information
 * @param {boolean} data.payout_to_master Pay out to master
 * @param {boolean} data.use_master_commission Use master commission
 * @return {Promise|Error} A resolved Promise with the company updated or Rejected with an Error
 */
export const updateCompany = (data: {
  name: string,
  payout_to_master: boolean,
  use_master_commission: boolean,
}): Promise<TTravelAgent> => {
  const query = {
    ...data,
    payout_to_master: data.payout_to_master ? 1 : 0,
    use_master_commission: data.use_master_commission ? 1 : 0,
  }

  return client.patch(COMPANY_ENDPOINT, { body: query })
}

export default updateCompany
